var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBackButton = function SvgBackButton(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.54038 13.4596C6.79422 13.7135 7.20578 13.7135 7.45962 13.4596C7.71346 13.2058 7.71346 12.7942 7.45962 12.5404L6.54038 13.4596ZM1 7L0.540381 6.54038C0.286541 6.79422 0.286541 7.20578 0.540381 7.45962L1 7ZM7.45962 1.45961C7.71346 1.20577 7.71346 0.794215 7.45962 0.540375C7.20578 0.286534 6.79422 0.286534 6.54038 0.540375L7.45962 1.45961ZM7.45962 12.5404L1.45962 6.54038L0.540381 7.45962L6.54038 13.4596L7.45962 12.5404ZM1.45962 7.45962L7.45962 1.45961L6.54038 0.540375L0.540381 6.54038L1.45962 7.45962Z",
    fill: "#0070E0"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBackButton, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/back-button.87a42b23.svg";
export { ForwardRef as ReactComponent };